import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import HeroSection from "./components/HeroSection";
import Navbar from './components/Navbar';

function App() {
  return (
    <Router>
       <Navbar />
      <Routes>
        {/* <Route path='/' element={<ComingSoon />} /> */}
        <Route path="/" element={<HeroSection />} />
      </Routes>
    </Router>
  );
}

export default App;
